export enum ConfirmResult {
  OK = "OK",
  CANCEL = "CANCEL",
  CANCEL_BY_HEADER = "CANCEL_BY_HEADER",
}
